<app-stages [stages]="stages" currentStage="Zgody"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate [formGroup]='form' (ngSubmit)="submitAndGoNext()">
    <fieldset>
      <legend>
        Zapoznaj się z regulaminem oraz klauzulą.
      </legend>
      <br>
      <app-accordion-group>
        <app-accordion-item [expanded]='false' name='Regulamin'>
          <ng-container *ngIf='subpages() | subpageContentByUrl: "regulamin" as subpage'>
            <div class='editor-content' [innerHTML]='subpage?.content'></div>
          </ng-container>
        </app-accordion-item>
      </app-accordion-group>
      <br>
      <div class='form-group' *ngIf='"regulations" as controlName'>
        <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
          <input
            [formControlName]='controlName'
            type='checkbox'
            [id]='controlName'
            [name]='controlName'>
          <label [for]='controlName'>
            * Zapoznałem/am się z regulaminem e-usługi
          </label>
        </div>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
      <app-accordion-group>
        <app-accordion-item [expanded]='false' name='Klauzula RODO'>
          <ng-container *ngIf='rodoContent() as content'>
            <div class='editor-content' [innerHTML]='content'></div>
          </ng-container>
        </app-accordion-item>
      </app-accordion-group>
      <br>
      <div class='form-group' *ngIf='"clause" as controlName'>
        <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
          <input
            [formControlName]='controlName'
            type='checkbox'
            [id]='controlName'
            [name]='controlName'>
          <label [for]='controlName'>
            * Zapoznałem/am się z klauzulą informacyjną RODO
          </label>
        </div>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
      @if (form.electronicCorrespondenceConsent) {
        <div class="editor-content">
          <article id="electronicCorrespondenceConsentDesc">
            <h3>
              Oświadczenie w sprawie korespondencji elektronicznej
            </h3>
            <p>
              * Wyrażam zgodę na doręczanie korespondencji w niniejszej sprawie za pomocą środków komunikacji
              elektronicznej w
              rozumieniu art. 2 pkt 5 ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną (Dz. U.
              z
              2020 r. poz. 344).
            </p>
          </article>
        </div>
        <div class='form-group' *ngIf='"electronicCorrespondenceConsent" as controlName'>
          <div class="custom-radio custom-inline" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
            <input
              aria-describedby="electronicCorrespondenceConsentDesc"
              [formControlName]="controlName"
              type="radio"
              id="electronicCorrespondenceConsentConfirm"
              [value]="true">
            <label for="electronicCorrespondenceConsentConfirm">Wyrażam zgodę</label>
          </div>
          <div class="custom-radio custom-inline" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
            <input
              aria-describedby="electronicCorrespondenceConsentDesc"
              [formControlName]="controlName"
              type="radio"
              id="electronicCorrespondenceConsentNotConfirm"
              [value]="false">
            <label for="electronicCorrespondenceConsentNotConfirm">Nie wyrażam zgody</label>
          </div>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      }
    </fieldset>
    <fieldset>
      <legend>
        Wyrażenie zgody na korzystanie z numeru telefonu wnioskodawcy
      </legend>
      <br>
      <p id="phoneInformationConsentDesc" class="mb-2">
        * Wyrażam zgodę na korzystanie z mojego numeru telefonu w celach informacyjnych:
      </p>
      <div class='form-group' *ngIf='"phoneInformationConsent" as controlName'>
        <div class="custom-radio custom-inline" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
          <input
            aria-describedby="phoneInformationConsentDesc"
            [formControlName]="controlName"
            type="radio"
            id="phoneInformationConsentConfirm"
            [value]="true">
          <label for="phoneInformationConsentConfirm">Wyrażam zgodę</label>
        </div>
        <div class="custom-radio custom-inline" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
          <input
            aria-describedby="phoneInformationConsentDesc"
            [formControlName]="controlName"
            type="radio"
            id="phoneInformationConsentNotConfirm"
            [value]="false">
          <label for="phoneInformationConsentNotConfirm">Nie wyrażam zgody</label>
        </div>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </fieldset>
    @if (form.partialTypeExemptionDeclare) {
      <fieldset>
        <legend>
          Dla rodzin wielodzietnych które posiadają kartę dużej rodziny
        </legend>
        <br>
        <div class='form-group' *ngIf='"partialTypeExemptionDeclare" as controlName'>
          <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
            <input
              [formControlName]='controlName'
              type='checkbox'
              [id]='controlName'
              [name]='controlName'>
            <label [for]='controlName'>
              * Oświadczam, że na nieruchomości wskazanej w deklaracji o wysokości opłaty za
              gospodarowanie odpadami komunalnymi zamieszkuje(-ją) rodzina(-ny) wielodzietna(-ne),
              o której(-rych) mowa w ustawie o Karcie Dużej Rodziny
            </label>
          </div>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </fieldset>
    }
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
